import { render, staticRenderFns } from "./TwitterSection.vue?vue&type=template&id=308adfa1"
import script from "./TwitterSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwitterSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports